import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'shared/assets/icons';
import { TopBarBase } from 'shared/components/connected/top-bar-base';

import * as Styled from './page-top-bar.style';

export const PageTopBar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <TopBarBase>
      <Styled.Container>
        <Styled.Title>
          <Styled.IconContainer>
            <Trash2 />
          </Styled.IconContainer>
          <Typography variant="h5" component="h1">
            {t('pages.trash.title') || 'Trash'}
          </Typography>
        </Styled.Title>
      </Styled.Container>
    </TopBarBase>
  );
};
